// features/policy/policySlice.js
/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance,{ axiosInstance9000 } from "../api/axiosInstance";

export const fetchPolicies = createAsyncThunk('policy/fetchPolicies', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance9000.get('/api/insured/my/policy');
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

const policySlice = createSlice({
  name: 'policy',
  initialState: {
    policies: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPolicies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPolicies.fulfilled, (state, action) => {
        state.loading = false;
        state.policies = action.payload;
      })
      .addCase(fetchPolicies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default policySlice.reducer;
